module.exports = __webpack_public_path__ + "img/registerOrange.537dbc57.jpg";